// extracted by mini-css-extract-plugin
export default {"splash":"splash_splash__4aiEG","lottie":"splash_lottie__smJno","text":"splash_text__xpknD","bar":"splash_bar__rk7LS","init":"splash_init__9m6rB"};